var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Lozenge from "@atlaskit/lozenge";
import React from "react";
export var errorList = ["failed", "error"];
export var statusLozenge = function (status) {
    var successList = ["completed", "success"];
    var inProgressList = ["in_progress"];
    status = status ? status.toLowerCase() : "";
    return successList.indexOf(status) >= 0 ? (React.createElement(Lozenge, { appearance: "success" }, status)) : errorList.indexOf(status) >= 0 ? (React.createElement(Lozenge, { appearance: "removed" }, status)) : inProgressList.indexOf(status) >= 0 ? (React.createElement(Lozenge, { appearance: "inprogress" }, status)) : (React.createElement(Lozenge, { appearance: "default" }, status));
};
export var parseInputNumber = function (event) {
    return event.target.value.length === 0 ||
        Number(event.target.value) === undefined ||
        isNaN(Number(event.target.value))
        ? 0
        : Number(event.target.value);
};
export var parseDateTime = function (dateTime) {
    if (!dateTime) {
        return "";
    }
    var parsedDate = new Date(dateTime);
    return parsedDate.toLocaleDateString() + " " + parsedDate.toLocaleTimeString();
};
export var parseDateTimeIso = function (dateTime) {
    var date = new Date(dateTime);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
};
export var getErrorMessage = function (reason) {
    var message = "";
    Object.entries(reason).forEach(function (entry) {
        var _a = __read(entry, 2), key = _a[0], val = _a[1];
        if (key === "message") {
            message = val;
        }
    });
    return message;
};
export var isFaultType = function (fault, faultExecution) {
    return fault.faultExecution !== undefined && fault.faultExecution === faultExecution;
};
